import React, { useMemo } from 'react';
import type { ACLResource, ACLAction } from '../../lib/acl/types';
import { useAuth } from '../../hooks';
import { Error, ERROR_TYPE } from './Error';

type RequireAuthProps = {
  resource?: ACLResource;
  action?: ACLAction | ACLAction[];
  authContext?: any;
  fallbackComponent?: React.ComponentType;
  children: React.ReactNode;
};

const PermissionPage = () => <Error type={ERROR_TYPE.PERMISSION_DENIED} />;

export const RequireAuth: React.FC<RequireAuthProps> = ({
  resource,
  action,
  authContext,
  children,
  fallbackComponent,
}) => {
  const auth = useAuth();
  const FallbackComponent = fallbackComponent ?? PermissionPage;

  if (!auth.requireLoggedIn()) {
    return null;
  }

  const isAllowed = useMemo(() => {
    if (!resource) {
      return true;
    }

    return Array.isArray(action)
      ? action.some((a) => auth.hasPermission(resource, a, authContext ?? {}))
      : auth.hasPermission(resource, action ?? 'retrieve', authContext ?? {});
  }, [action, resource]);

  if (isAllowed) {
    return <>{children}</>;
  } else {
    return <FallbackComponent />;
  }
};
